import React, { forwardRef } from 'react';
import ReactSelect from 'react-select';

import Text from '../Text';

import Async from './Async';
import * as Styled from './styles';

export function Select(
  {
    label,
    labelTextColor,
    error,
    placeholder = 'Selecione...',
    onChange,
    value,
    options = [],
    multiple,
    disableClear = false,
    isDisabled = false,
    getOptionLabel,
    getOptionValue,
    autoFocus = false,
    ...props
  },
  ref
) {
  const styledSelect = {
    singleValue: provided => ({
      ...provided,
      color: '#494950',
    }),
  };

  return (
    <Styled.Container>
      {label && (
        <Styled.Label color={labelTextColor || '#464e5f'} type="label">
          {label}
        </Styled.Label>
      )}
      <ReactSelect
        styles={styledSelect}
        isDisabled={isDisabled}
        value={value}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={onChange}
        options={options}
        ref={ref}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        isClearable={disableClear ? false : !!value}
        isMulti={multiple}
        noOptionsMessage={() => <Text>Nenhuma opção encontrada</Text>}
        components={{
          Control: ({ innerRef, innerProps, children }) => {
            return (
              <Styled.Control innerRef={innerRef} {...innerProps} error={error}>
                {children}
              </Styled.Control>
            );
          },
          ValueContainer: ({ innerRef, innerProps, children }) => {
            return (
              <Styled.ValueContainer innerRef={innerRef} {...innerProps}>
                {children}
              </Styled.ValueContainer>
            );
          },
          MultiValue: ({ children, components: Components, removeProps }) => (
            <Styled.MultiValue>
              <Text type="label">{children}</Text>
              <Styled.MultiValueRemove {...removeProps}>
                <Components.Remove />
              </Styled.MultiValueRemove>
            </Styled.MultiValue>
          ),
        }}
        {...props}
      />
      {error && (
        <Styled.ErrorText color="error" type="little">
          {error}
        </Styled.ErrorText>
      )}
    </Styled.Container>
  );
}

Select.Async = Async;

export default forwardRef(Select);
